import React, { useState } from 'react'
import Menu from '../../menu/menu'

import type { Order, RemedialReason } from '../../../../utils/types'

import '../combo-group.css'

type ReasonsProps = {
    reasons: Array<RemedialReason>,
    register: any,
    order: any,
    actions: any
}


const Reasons: React.FC<ReasonsProps> = ({ reasons, register, order, actions }) => {
    const [tab, setTab] = useState(0);

    return (
        <div className="combo-group">
            <aside>
                <button disabled={tab === 0} onClick={() => setTab(0)} type="button">Reason 1</button>
                <button disabled={tab === 1} onClick={() => setTab(1)} type="button">Reason 2</button>
                <button disabled={tab === 2} onClick={() => setTab(2)} type="button">Reason 3</button>
                <button disabled={tab === 3} onClick={() => setTab(3)} type="button">Reason 4</button>
                <button disabled={tab === 4} onClick={() => setTab(4)} type="button">Reason 5</button>
                <button disabled={tab === 5} onClick={() => setTab(5)} type="button">Reason 6</button>
                <button disabled={tab === 6} onClick={() => setTab(6)} type="button">Reason 7</button>
                <button disabled={tab === 7} onClick={() => setTab(7)} type="button">Reason 8</button>
            </aside>
            <div className="p-3 w-full">
                {
                     [
                        {
                            code: 'REASON_CODE_1',
                            note: 'REASON_NOTE_1'
                        },
                        {
                            code: 'REASON_CODE_2',
                            note: 'REASON_NOTE_2'
                        }, {
                            code: 'REASON_CODE_3',
                            note: 'REASON_NOTE_3'
                        }, {
                            code: 'REASON_CODE_4',
                            note: 'REASON_NOTE_4'
                        }, {
                            code: 'REASON_CODE_5',
                            note: 'REASON_NOTE_5'
                        }, {
                            code: 'REASON_CODE_6',
                            note: 'REASON_NOTE_6'
                        }, {
                            code: 'REASON_CODE_7',
                            note: 'REASON_NOTE_7'
                        }, {
                            code: 'REASON_CODE_8',
                            note: 'REASON_NOTE_8'
                        }
                    ].map((row:any, i:number) => {

                        let defaultCode: any = null;
                            //let defaultCodeLabel = null;
                            let defaultNote = null;
                            if(order[row.code as keyof Order]) {
                                defaultCode = order[row.code as keyof Order]
                            }
                            if(order[row.note as keyof Order]) {
                                defaultNote = order[row.note as keyof Order]
                            }
                            if(actions.submission[order.ORDER_REF] && (actions.submission[order.ORDER_REF][row.code as keyof Order] || actions.submission[order.ORDER_REF][row.code as keyof Order] === '')) {
                                defaultCode = actions.submission[order.ORDER_REF][row.code as keyof Order]
                                //defaultCodeLabel = '- Select reason -'
                            }
                            if(actions.submission[order.ORDER_REF] && (actions.submission[order.ORDER_REF][row.note as keyof Order] || actions.submission[order.ORDER_REF][row.note as keyof Order] === '')) {
                                defaultNote = actions.submission[order.ORDER_REF][row.note as keyof Order]
                            }

                            if(defaultCode) {
                                let t = reasons.find(reason => {
                                    return reason.id.toString() === defaultCode
                                })
                                //defaultCodeLabel = t ? `${t.code} - ${t.reason}` : defaultCodeLabel
                            }


                        return (
                            <div  className="combo-group__matter" key={i} aria-visible={tab === i}>
                                {/*<Select
                                    value={defaultCode}
                                    placeholder={defaultCodeLabel || '- Select reason code -'}
                                    options={reasons.map((reason) => ({
                                        value: reason.id.toString(),
                                        label: `${reason.code} - ${reason.reason}`
                                    }))}
                                    isClearable={true}
                                    {...register(row.code)}
                                    className="order-2"
                                    classNamePrefix={'fim'}
                                    isSearchable={false}
                                    onChange={({ value }) => {
                                        actions.setSubmission({
                                            ...actions.submission,
                                            [order.ORDER_REF]: {...actions.submission[order.ORDER_REF], [row.code]: value}
                                        })
                                    }}
                                />*/}

                                <Menu
                                    hot={defaultCode}
                                    fallback={defaultCode}
                                    options={reasons.map((reason) => ({
                                        value: reason.id.toString(),
                                        label: `${reason.code} - ${reason.reason}`
                                    }))}
                                    onClear={() => {
                                        actions.setSubmission({
                                            ...actions.submission,
                                            [order.ORDER_REF]: {...actions.submission[order.ORDER_REF], [row.code]: ''}
                                        })
                                    }}
                                    onSelect={(value:string) => {
                                        actions.setSubmission({
                                            ...actions.submission,
                                            [order.ORDER_REF]: {...actions.submission[order.ORDER_REF], [row.code]: value}
                                        })
                                    }}
                                />

                                <textarea
                                    rows={3}
                                    name={row.note}
                                    //disabled={!defaultCode}
                                    placeholder={'Type note (1500 characters maximum)'}
                                    maxLength={1500}
                                    onChange={({ target: { name, value, validity: { valid } }, ...props }) => {
                                        if(!valid) { return; }

                                        //debounced(name, value);
                                        actions.setSubmission({
                                            ...actions.submission,
                                            [order.ORDER_REF]: {...actions.submission[order.ORDER_REF], [name]: value}
                                        })
                                    }}
                                    value={defaultNote || ''}
                                />
                                <button
                                    className='text-red mt-4'
                                    type="button"
                                    onClick={() => {
                                        actions.setSubmission({
                                            ...actions.submission,
                                            [order.ORDER_REF]: {...actions.submission[order.ORDER_REF], [row.note]: '', [row.code]: ''}
                                        })
                                    }}
                                >Clear Reason</button>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
export default Reasons